import React, { FC, useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// components
import AppTemplate from '../../templates/appTemplate';
import QrScan from '../../organisms/qrScan';
// actions
import appAction from '../../../redux/actions/app';
// localization
import strings from '../../../localization';
import { getSelfTestPathFromQrPayload } from '../../../tools';

// Hosts mobile QR scan flow; footer Back uses default primary submit style (see Footer).
const QrScanPage: FC = () => {
  const [isScanned, setIsScanned] = useState<boolean>(false);
  const [link, setLink] = useState<string>('');

  const history = useHistory();
  const dispatch = useDispatch();
  const language = link.substring(link.lastIndexOf('/') + 1);

  useEffect(() => {
    strings.setLanguage(language);
  }, [language]);

  // Persists a valid self-test QR payload and opens confirmation; invalid codes show a toast only.
  const handleScan = useCallback(
    (data: string | null) => {
      if (!data) {
        return;
      }

      if (!getSelfTestPathFromQrPayload(data)) {
        dispatch(appAction.appFlashMessage(strings.selfTest.invalidQrFlash, 'error'));
        return;
      }

      try {
        setLink(data);
      } catch (e) {
        setLink('');
      }
      setIsScanned(true);
    },
    [dispatch],
  );

  // Surfaces camera permission or startup failures to the user.
  const handleError = useCallback(
    (message: string) => {
      dispatch(appAction.appFlashMessage(message, 'error'));
    },
    [dispatch],
  );

  // Navigates into the self-test route when the stored payload matches the app QR contract.
  const handleSubmit = useCallback(() => {
    if (!link) {
      return;
    }
    const path = getSelfTestPathFromQrPayload(link);
    if (!path) {
      dispatch(appAction.appFlashMessage(strings.selfTest.invalidQrFlash, 'error'));
      return;
    }
    history.push(path);
  }, [link, dispatch, history]);

  const handleCancel = () => {
    if (isScanned) {
      setIsScanned(false);
      if (link) {
        setLink('');
      }
    } else {
      history.push({
        pathname: '/login',
      });
    }
  };

  return (
    <AppTemplate
      className=" content--qr-scan"
      isHeaderHidden={true}
      submitHidden={!link}
      submitLabel={strings.connectPage.labels.startTest}
      handleSubmit={handleSubmit}
      handleCancel={handleCancel}
      heading=""
      description=""
      isIntegration={false}
    >
      <QrScan data={link} handleScan={handleScan} isScanned={isScanned} handleError={handleError} />
    </AppTemplate>
  );
};

export default QrScanPage;
